import React , {useState, useReducer, useEffect} from 'react'
import Styles from './index.module.scss';
import { DateRangeInput, MultiSelect, Slider, Tag, Input, DatePickerInput, Button, HelpText } from '@kaleyra/kds';
import { DateRangePicker, RadioGroup, Radio, Spinner, Toast} from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { isArray, isEmpty } from 'lodash';
import AdvanceFilter from '../../../../../../../components/AdvanceFilter/AdvanceFilter';
import { getEmailStatus, getFromAddressList } from '../../../../../../../store/actions/emailStatus.action';
import { useDispatch, useSelector } from 'react-redux';
import { IStateType } from '../../../../../../../store/models/root.interface';
import { MultiSelectDataType } from '@kaleyra/kds/dist/src/atoms/MultiSelect';

export type MapStateType = {
	data: any;
};
type RequestReportPropType = {
	getOptions: any;
}
export type DispatchPropsType = {
	onClose: () => void;
	onSave: (applyTemplateData: any, callback: (resp: any, flag: boolean) => void) => void;
	onLoad: () => void;
	onLoadData: () => void;
};

type ReportType =
	| "tabular"
	| "summary"
	| ""
interface RequestReport {
	"reportName": string,
	"reportType": ReportType,
	"startDate": Date | undefined,
	"endDate": Date | undefined,
	"status": string[],
	"fromEmail": string[],
	"msgId": string[],
}
type requestReportFildName =
	| "reportName"
	| "reportType"
	| "startDate"
	| "endDate"
	| "status"
	| "fromEmail"
	| "msgId"

const initialState: RequestReport = {
	"reportName": '',
	"reportType": 'tabular',
	"startDate": undefined,
	"endDate": undefined,
	"status": [],
	"fromEmail": [],
	"msgId": [],
}

const stateReducer = (state: RequestReport, newState: Partial<RequestReport>) => ({ ...state, ...newState })

const RequestReportTemplate : React.FC<RequestReportPropType & DispatchPropsType & MapStateType> =  ({
    onClose,
	onLoad,
	onLoadData,
	onSave,
	data
}) => { 
    const [filterVisible, setFilterVisible] = useState<boolean>(false);
    const [requestInprogress, SetRequestInprogress] = useState(false);
	const [requestReportForm, setRequestReportForm] = useReducer(stateReducer, initialState);
	const [dateRange, setDateRange] = useState<any>([]);
	const [dateError, setDateError] = useState('');
	const [titleError, setTitleError] = useState('');
	const dispatch = useDispatch();
	const {emailStatus_data, fromEmailList_data} = useSelector((state : IStateType) => state.emailStatus);
    const {t} = useTranslation();
    
	useEffect(()=>{
		dispatch(getEmailStatus());
		dispatch(getFromAddressList());
	},[])

    const onChange = (event: any) => {
        let field = event.target.name;
		let value = event.target.value;
		setRequestReportForm({ [field]: value });
	};
	const resetError = ()=>{
		setDateError('');
		setTitleError('');
	}
	const handleRequestInprogress = () => {
		SetRequestInprogress(!requestInprogress);
	}
    const handleAdvanceFilterBtnClick = () =>{
        setFilterVisible(true);
    }
	const handleFilterVisibility = () => {
		setFilterVisible(!filterVisible);
	};
	const resetFilter = ()=>{
		setRequestReportForm({
			"status" : [],
			"fromEmail" : []
		})
	}
	const onCancelFilter = () => {
		resetFilter();
		handleFilterVisibility()
	}
    const handleSliderClose = ()=>{
        if(filterVisible){
            setFilterVisible(false);
        }
        else{
            onClose();
        }
    }
	const setReportName = (e :any)=>{
		let value = e.target.value;
		setRequestReportForm({ ["reportName"]: value });
	}
    const generatePills = ()=>{
        let statusPill;
        let fromEmailPill;
        let combinePill = [];
        statusPill = requestReportForm.status.join(',');
        fromEmailPill = requestReportForm.fromEmail.join(',');
        combinePill.push({
            label : "Status",
            value : statusPill
        });
        combinePill.push({
            label : "From Email",
            value : fromEmailPill
        })

        return combinePill;
    }
	const handlePillClose = (label : string)=>{
		switch(label){
			case "Status" : {	
				setRequestReportForm({ ["status"]: [] });
				break;
			}
			case "From Email" :{
				setRequestReportForm({ ["fromEmail"]: [] });
				break;
			}
		}
	}
	const onStartDateChange = (date : Date | undefined)=>{
		setRequestReportForm({['startDate'] : date})
	}
	const getEmailStatusList = ():MultiSelectDataType[] => {
		let emailStatus : MultiSelectDataType[] = emailStatus_data.map((status : string, i) : MultiSelectDataType=>{
			return (
				{
					index : i.toString(),
					label : status
				}
			)
		});
		return emailStatus;
	}
	const getFromEmailList = ():MultiSelectDataType[] => {
		let fromEmailList : MultiSelectDataType[] = fromEmailList_data.map((status : string, i) : MultiSelectDataType=>{
			return (
				{
					index : i.toString(),
					label : status
				}
			)
		});
		return fromEmailList;
	}
	const onEndDateChange = (date : Date | undefined)=>{
		setRequestReportForm({['endDate'] : date})
	}
    const renderRequestFormBody = ()=>{
        const { reportName, reportType, startDate, endDate } = requestReportForm;
        return (
            <div className={Styles.formWrapper}>
                <p className={Styles.secondaryTextStyle}>{t("KLR0035")}</p>
				<div className={Styles.formElementStyle}>

					<div className={Styles.dateRangeWrapper}>
						<DatePickerInput
							topLabel='From'
							showTopLabel
							placeholder="dd/mm/yyyy"
							value = {startDate}
							setDate={onStartDateChange}
							/>
						<DatePickerInput
							topLabel='To'
							showTopLabel
							placeholder="dd/mm/yyyy"
							value = {endDate}
							setDate={onEndDateChange}
							/>
						
					</div>
					{dateError && <HelpText type='error'>{dateError}</HelpText>}
				</div>
                <div className={Styles.reportTypeContainer}>
					<p className={Styles.secondaryTextStyle}>{t("typeOfReport")}</p>
					<RadioGroup
						className={Styles.radioGroupContainer}
						value={reportType}
						onChange={onChange}
						name={'reportType'}
					>
						<Radio name={'reportType'} value={'tabular'} checked={true} >
							<span className={Styles.radioOptionStyle}>
								{t('detailed')}
							</span>
						</Radio>

						<Radio name={'reportType'} value={'summary'} >
							<span className={Styles.radioOptionStyle}>
								{t('summary')}
							</span>
						</Radio>

					</RadioGroup>
					<div className={Styles.advanceFilterWrapper}>
						<AdvanceFilter 
							title='Advance Filter' 
							subtitle='Set filter to narrow down the result' 
							buttonName='Edit Filters'
							handleButtonClick={handleAdvanceFilterBtnClick}
							pills={generatePills()}
							handlePillClose={handlePillClose}
						/>
					</div>
					<br/>
					<div className={Styles.formElementStyle}>
						<Input
						placeholder={t('mainTitle')}
						value={reportName}
						// name="reportName"
						onChange={setReportName}
						/>
						{titleError && <HelpText type='error'>{titleError}</HelpText>}
					</div>
                </div>
            </div>
        )
    }
    const onMultiSelectChange = (field: string, value: any) => {
		setRequestReportForm({ [field]: value });
	};
    const renderFilter = ()=>{
        const { status, fromEmail} = requestReportForm;
        return (
            <div className={Styles.formWrapper}>
                <MultiSelect
                    data = {getEmailStatusList()}
                    label='Status'
                    placeholder='Select status'
                    selected={status}
                    showLabel
                    onChangeSelected={(value)=>onMultiSelectChange("status", value)}
                />
                <div className='my-2'></div>
                <MultiSelect
                    data = {getFromEmailList()}
                    label='From Email Address'
                    placeholder='Select from email address'
                    selected={fromEmail}
                    showLabel
                    onChangeSelected={(value)=>onMultiSelectChange("fromEmail", value)}
                />
            </div>
        )
    }
	const getFooter = (): React.ReactNode => {
		return (
			filterVisible ? (<div className={Styles.footerContainer}>
				<Button type="default" onClick={onCancelFilter}>
					{t('mainCancel')}
				</Button>
				<Button type="primary" onClick={handleFilterVisibility}>
					{t('apply')}
				</Button>
			</div>) :
				(<div className={Styles.footerContainer}>
					<Button type="default" onClick={onClose}>
						{t('mainCancel')}
					</Button>
					<Button type="primary" disabled={requestInprogress} onClick={onRequestReportSave}>
						{requestInprogress ? <Spinner /> : t('mainSave')}
					</Button>
				</div>)
		);
	};
	const  isDateInRange = (fromDate:Date, toDate:Date) : {isValid: boolean, error : string}  =>{
		// Get the current date
		const currentDate = new Date();
	  
		// Calculate the date three months ago
		const threeMonthsAgo = new Date();
		threeMonthsAgo.setMonth(currentDate.getMonth() - 3);
	  
		// Check if ToDate is not greater than today's date
		if (toDate > currentDate) {
			return {
			  isValid: false,
			  error: "ToDate should not be greater than today's date"
			};
		  }
		
		// Check if FromDate is before or equal to ToDate
		if (fromDate > toDate) {
		  return {
			isValid : false,
			error :  "FromDate should be on or before ToDate"
		  };
		}
		
		// Check if FromDate is within the last 3 months
		if (fromDate < threeMonthsAgo) {
		  return {
			isValid : false,
			error : "FromDate should be within the last 3 months"
		  };
		}
	  
		// Check if ToDate is within the last 3 months
		if (toDate < threeMonthsAgo) {
		  return {
			isValid : false,
			error : "ToDate should be within the last 3 months"
		  };
		}
	  
		// If everything is fine, return true
		return {
			isValid : true,
			error : ""
		};
	  }
	const callback = (response: any, flag: boolean) => {
		handleRequestInprogress();
		if (flag && response.data && isEmpty(response.error)) {
			Toast(response.message, 'success');
			onClose();
			onLoad();
			if (!isEmpty(data.emailReportData) && data.emailReportData.data.length === 0) {
				onLoadData();
			}
		} else if (!isEmpty(response.error)) {
			Object.keys(response.error).forEach((key: any) => {
				Toast(response.error[key], 'error');
			});
		} else {
			Toast(response.message, 'error');
		}
	}
	const onRequestReportSave = () => {
		const { reportName, reportType, startDate, endDate, status, fromEmail, msgId} = requestReportForm;
		resetError();
		if (reportName === '') {
			setTitleError(t("BLD01535"));
			return;
		}
		if (reportType === '') {
			Toast(t("BLD01536"), "error");
			return;
		}
		if (startDate === undefined) {
			setDateError(t("BLD01537"));
			return;
		}
		if (endDate === undefined) {
			setDateError(t("BLD01538"));
			return;
		}
		const dateRangeRes = isDateInRange(startDate, endDate);
		if(!dateRangeRes.isValid){
			setDateError(dateRangeRes.error);
			return;
		}
		let saveDataOb: any = {
			"report_name": reportName,
			"report_type": reportType,
			"Start_Date": startDate.toLocaleDateString("en-GB"),
			"End_Date": endDate.toLocaleDateString("en-GB"),
			"status": status,
			"from_mail": fromEmail,
			"email_id" : msgId
		}

		var formData = new FormData();
		for (var key in saveDataOb) {
			if(Array.isArray(saveDataOb[key])){
				for (let k in saveDataOb[key]){
					formData.append(key+"[]",saveDataOb[key][k]);
				}
			}else{
				formData.append(key, saveDataOb[key]);
			}		
		}
		handleRequestInprogress();
		onSave(formData, callback);
	}
    return (
        <Slider
            visibility={true}
            containerId='root-modal'
            label={filterVisible ? "Choose Filter" :"Generate New Report"}
            onClose={handleSliderClose}
            enableBackButton = {filterVisible}
			footer = {getFooter()}
        >
            {!filterVisible && renderRequestFormBody()}
			{filterVisible && renderFilter()}
        </Slider>
    )
}

export default RequestReportTemplate